import { createContext } from 'react';
import TrackingContextState from './TrackingContext.types';

const TrackingContext = createContext<TrackingContextState>({
  track: () => {},
});

export default TrackingContext;
